export default {
  name: 'Header',
  methods: {
    changeLanguage () {
      this.$i18n.locale = this.$i18n.locale === 'es-CL' ? 'en-US' : 'es-CL'
    }
  }
}
